import { render, staticRenderFns } from "./addLeadsModal.vue?vue&type=template&id=68957726&scoped=true"
import script from "./addLeadsModal.vue?vue&type=script&lang=js"
export * from "./addLeadsModal.vue?vue&type=script&lang=js"
import style0 from "./addLeadsModal.vue?vue&type=style&index=0&id=68957726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68957726",
  null
  
)

export default component.exports